const CollectSmallIcon = () => {
  return (
    <svg
      width="28"
      height="32"
      viewBox="0 0 28 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="13"
        width="26"
        height="18"
        rx="3"
        fill="white"
        stroke="#FFCF23"
        strokeWidth="2"
      />
      <path
        d="M7 21V21C11.0281 17.5474 16.9719 17.5474 21 21V21"
        stroke="#FFCF23"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 21V21C16.9719 17.5474 11.0281 17.5474 7 21V21"
        stroke="#FFCF23"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="14"
        cy="8"
        r="7"
        fill="white"
        stroke="#FFCF23"
        strokeWidth="2"
      />
      <path
        d="M14.0023 3C11.2395 3 9 5.25576 9 8.04041C9 10.5099 10.762 12.563 13.0885 12.9934C13.1022 12.9948 13.116 12.9948 13.1297 12.9934C13.1841 12.9934 13.2365 12.9744 13.276 12.9403C13.3154 12.9062 13.339 12.8596 13.3417 12.8101L13.6255 8.26807C13.6255 8.17713 13.6652 8.08992 13.7358 8.02562C13.8065 7.96131 13.9024 7.92519 14.0023 7.92519C14.1022 7.92519 14.1981 7.96131 14.2687 8.02562C14.3394 8.08992 14.3791 8.17713 14.3791 8.26807L14.6598 12.7962V12.8296C14.6658 12.8762 14.6904 12.9192 14.7289 12.9504C14.7674 12.9816 14.8172 12.9989 14.8688 12.9989C14.8825 13.0004 14.8963 13.0004 14.91 12.9989C17.238 12.5686 19 10.5155 19 8.04596C19.003 5.25576 16.7651 3 14.0023 3ZM12.582 9.09263C10.759 10.1851 10.3486 7.96406 10.2647 7.20474L10.2494 7.14366C10.2529 7.10479 10.2706 7.06812 10.2998 7.03954L10.3089 7.02983H10.3181C10.3499 7.00301 10.3908 6.98685 10.434 6.98402L10.5011 6.99096C11.3402 7.06176 13.7811 7.43517 12.582 9.09263ZM14.0023 7.09368C11.8665 6.6925 13.3005 4.85736 13.8299 4.26739C13.8436 4.24934 13.8604 4.23269 13.8726 4.2188C13.9049 4.19321 13.9458 4.1785 13.9886 4.17716H14.0145C14.0577 4.17874 14.099 4.19339 14.132 4.2188C14.1442 4.23269 14.1594 4.24934 14.1731 4.26739C14.704 4.85736 16.1396 6.6925 14.0023 7.09368ZM15.4211 9.13844C14.2159 7.4782 16.6567 7.10479 17.4958 7.02844L17.5721 7.0215C17.615 7.02436 17.6558 7.03997 17.688 7.06592C17.696 7.06945 17.7024 7.07532 17.7063 7.08258C17.735 7.11182 17.7522 7.14895 17.7551 7.18808C17.7551 7.20612 17.7551 7.22833 17.7475 7.24916C17.6545 8.00709 17.2456 10.2295 15.4211 9.13844Z"
        fill="#FFCF23"
      />
    </svg>
  );
};

export default CollectSmallIcon;
